<template>
    <base-activation-piece
        :header-text="headerText"
        :url="url"
        :thumbnail="thumbnail"
        :is-image="!!thumbnail"
        :file-name="url"
        :date="date"
        :content-id="contentId"
        :network-id="networkId"
        :hide-actions="hideActions"
    />
</template>

<script>
    import { computed, toRefs } from 'vue-demi';
    import { NETWORK_LABEL_MAP } from '../../constants/networks';
    import FILE_DISPLAY_NAMES from '../../constants/file-display-names';
    import BaseActivationPiece from './BaseActivationPiece.vue';

    export default {
        name: 'ActivationContent',
        components: {
            BaseActivationPiece
        },
        props: {
            type: {
                type: String,
                default: null
            },
            date: {
                type: String,
                default: undefined
            },
            thumbnail: {
                type: String,
                default: undefined
            },
            url: {
                type: String,
                default: undefined,
                required: true
            },
            contentId: {
                type: Number,
                default: null
            },
            networkId: {
                type: Number,
                default: null
            },
            hideActions: {
                type: Boolean,
                default: false
            }
        },

        setup(props) {
            const { type } = toRefs(props);

            const headerText = computed(() => {
                if (NETWORK_LABEL_MAP.hasOwnProperty(type.value)) {
                    return NETWORK_LABEL_MAP[type.value];
                }

                return FILE_DISPLAY_NAMES.default;
            });

            return {
                headerText
            };
        }
    };
</script>
